import { radioAnatomy as parts } from "@chakra-ui/anatomy"
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system"

const { defineMultiStyleConfig, definePartsStyle } =
  createMultiStyleConfigHelpers(parts.keys)

const variantEmphasized = definePartsStyle({
  label: {
    fontWeight: 600,
  },
})

const variantTab = definePartsStyle({
  container: {
    p: { base: 3, md: 4 },
    border: "1px solid",
    borderColor: "neutrals.300",
    borderRadius: "xl",
    _checked: {
      bg: "main.100",
      borderColor: "main.700",
    },
  },
  label: {
    ml: { base: 3, md: 4 },
    fontWeight: 700,
  },
})

/**
 * @see {@link https://github.com/chakra-ui/chakra-ui/blob/v2/packages/theme/src/components/radio.ts}
 */
export const Radio = defineMultiStyleConfig({
  variants: {
    emphasized: variantEmphasized,
    tab: variantTab,
  },
  defaultProps: {
    colorScheme: "primary",
  },
})
